import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import html from '@mailobj-browser/front/js/fetchers/html.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import before from '@mailobj-browser/front/js/tree/before.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { dropZone } from '../selectors/drop.js'
import { block, elements } from './styles.js'
import { elements as genericsElements } from '../styles.js'

const lists = new WeakMap()

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    xaddrs,
    event
  ) => {
    const { target } = event
    const chip = closest(`.${genericsElements.chip}`, target)

    if (chip) {
      return
    }

    if (!xaddrs.disabled) {
      one(`.${elements.add_input}`, xaddrs).focus()
    }
  }
})

export default (
  xaddrs
) => {
  const ol = one('ol', xaddrs)
  const add = one(`.${elements.add}`, ol)
  const first = one('li', ol)
  const loading = one(`.${elements.loading}`, xaddrs)

  lists.set(xaddrs, object(null, { add, first, loading }))

  onClick.listen(xaddrs)

  dropZone(ol, {
    contact: async (target, dragged) => {
      const { lastChild } = ol

      if (closest('[data-contract="xaddrs.list"]', dragged)) {
        before(lastChild, dragged)

        return
      }

      const { dataset: { dropType } } = target
      const { dataset: { dragHref } } = dragged
      const url = new URL(dragHref, location)
      const { searchParams } = url

      searchParams.set('format', dropType)

      const request = new Request(`${url}`)
      const { element } = await html(object(null, { request, target }))
      const { children } = element

      before(lastChild, ...children)
    }
  })
}

export const list = (
  element
) => {
  return lists.get(closest(`.${block}`, element))
}
